import http from "infra/http";
import { useQuery } from "react-query";
import { DocumentoForm } from "../typings";

function useDocumento(id?: string) {
  return useQuery(`/v1/documento/${id}`, async () => {
    const { data } = await http.get<DocumentoForm>(
      `/v1/documento/${id}`,
    );

    return data;
  }, {
    enabled: !!id,
  });
}

export default useDocumento;
